import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { AuthSessionContext } from '@context/AuthContext'

import { Title1 } from '@ui/Typography'
import { LogoIcon } from '@ui/icons/LogoIcon'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { getRedirectDomain } from '@utils/companyName.utils'

import { PageNotFound } from '@global/notFound/PageNotFound'

import styles from './WrongEntityPage.module.scss'

export const WrongEntityPage: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [auth, setAuth] = useContext(AuthSessionContext)
  const apiClient = useApiClient(ClientApiClient)
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (auth?.tickmillCompany.id) {
        try {
          apiClient.logOut(auth?.id).then(() => {
            setAuth(null)
            window.location.replace('https://' + getRedirectDomain(auth?.tickmillCompany.id))
          })
        } finally {
          setAuth(null)
          navigate('/login')
        }
      } else {
        try {
          if (auth?.id) {
            apiClient.logOut(auth?.id).then(() => {
              setAuth(null)
              navigate('/login')
            })
          } else {
            setAuth(null)
            navigate('/login')
          }
        } catch (e: unknown) {
          console.error(e)
        }
      }
    }, 1000)
    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!auth?.tickmillCompany) {
    return <PageNotFound />
  }
  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <LogoIcon size={80} color='text-primary-med-em' secondaryColor='text-secondary-med-em' />
          <Title1>{t('You have logged in to the Client Area from a different domain.')}</Title1>
          <Title1>{t('You will be shortly redirected to the entity where you registered.')}</Title1>
        </div>
      </div>
    </div>
  )
}
